import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import DateTimePicker from "react-datetime-picker";

import styled from "styled-components";

import { FormControlType, getDecimalString, getIntegerString } from "./Helper2";

import { ModalSelectBlack } from "../features/RadConnStyle";
import {
  CreateTooltip,
  DeepMergeObject,
  DotStringToObject,
  GetDeepValue,
  MysqlDateCV,
} from "./Helper";
import { ConvertDateFromSQL, ConvertEngDateFromSQL } from "./ThaiDate";
import {
  FormControlBlack,
  InputGroupBlack,
  LabelBlack,
} from "../pages/components/PageParams";

/**
 * สร้าง Object ของ Form
 * พร้อม สร้างชุด Field ข้อมูลเริ่มต้นสำหรบั state-object [data, setData]
 *
 * @param {} props
 * @returns
 */
export default function FormAutoObject(props) {
  const [data, setData] = props.dataValue;

  const updateData = (value, item) => {
    if (!item.fieldName) return;
    setData((pv) => ({ ...pv, [item.fieldName]: value }));
  };

  const onDecimalBlure = (e, item, digits) => {
    updateData(getDecimalString(e.target.value, digits), item);
  };

  const onNumberBlure = (e, digit) => {
    e.target.value = getIntegerString(e.target.value);
  };

  const onKeyDown = (e) => {
    if (e.keyCode == 13) {
      e.target.value = getDecimalString(e.target.value);
      e.target.select();
    }
  };
  const onDecimalFocus = (e) => {
    e.target.select();
  };

  const onTextChange = (value, item) => {
    updateData(value, item);
  };

  const onSelectChange = (value, item, e) => {
    if (!item.fieldName) return;

    setData((pv) => ({
      ...pv,
      ...DeepMergeObject(
        DotStringToObject(item.fieldName + "." + item.selectValueName, value),
        DotStringToObject(
          item.fieldName + "." + item.selectDisplayName,
          e.target[e.target.selectedIndex].text,
        ),
      ),
    }));
  };

  const onCheckBoxChange = (value, item) => {
    updateData(value, item);
  };

  const buildDefaultEmpty = (item) => {
    if (!data) {
      console.log("data", data);
      return;
    }

    if (data[item?.fieldName] === undefined) {
      switch (item.formControlType) {
        case FormControlType.DECIMAL_LOCK_VALUE:
          updateData(getDecimalString("0.00"), item);
          return;
        case FormControlType.DECIMAL:
          //
          updateData(getDecimalString("0.00"), item);
          return;
        case FormControlType.DATE_PICKER:
          updateData(item?.value ?? new Date(), item);
          break;

        case FormControlType.SEARCHER:
          defaultValueSearcher(item);
          break;

        case FormControlType.SELECT:
          defaultValueSelect(item);
          break;

        default:
          updateData(item?.value ?? null, item);
          return;
      }
    }
  };

  const defaultValueSearcher = (item) => {
    setData((pv) => ({
      ...pv,
      ...DotStringToObject(item?.fieldName + "." + item?.searchValueName, 0),
    }));
  };

  const defaultValueSelect = (item) => {
    if (item.selectData) {
      if (item.selectData.length > 0) {
        setData((pv) => ({
          ...pv,
          ...DotStringToObject(
            (item?.selectBuildObjectPath ?? item.fieldName) +
              "." +
              item.selectValueName,
            GetDeepValue(item.selectData?.[0], item.selectValueName, 0),
          ),
        }));
      } else updateData(item?.value ?? null, item);
    }
  };

  const itemChanged = (e, item) => {
    if (item.onChange) item.onChange(e.target.value, item);
    else onTextChange(e.target.value, item);
  };

  const getFormatDefaultValue = (item) => {
    switch (item.formControlType) {
      case FormControlType.DECIMAL:
        return getDecimalString(data[item.fieldName], 2);
      case FormControlType.DECIMAL_LOCK_VALUE:
        return getDecimalString(data[item.fieldName], 2);
      case FormControlType.NUMERIC:
        return getDecimalString(data[item.fieldName], 0);
      default:
        return data[item.fieldName];
    }
  };

  const getControl = (item, props) => {
    return (
      <FormControlBlack
        {...props}
        aria-label={item.caption}
        name={item.fieldName}
        key={item.fieldName}
        required={item.isRequired}
        disabled={item.disabled}
        readOnly={item.readOnly ?? false}
        defaultValue={getFormatDefaultValue(item)}
        placeholder={"ระบุ" + item.caption + " .."}
        onChange={(e) => itemChanged(e, item)}
        style={{ ...{ minWidth: "100%" }, ...item.inputStyle }}
      />
    );
  };

  return (
    <Form
      {...props}
      key={props?.formId ?? "form1"}
      id={props?.formId ?? "form1"}
      ref={props?.refTo}
      // style={props?.style}
      onSubmit={props.onSubmitForm ? props.submit : (e) => e.preventDefault()}
    >
      {
        props.items &&
          props.items.map((item) => {
            // Build default value when empty
            buildDefaultEmpty(item);

            switch (item.formControlType) {
              case FormControlType.TEXT:
                return (
                  <InputGroupBlack key={item.fieldName}>
                    <LabelBlack style={item.labelStyle}>
                      {item.caption}
                    </LabelBlack>
                    {getControl(item, {
                      type: "text",
                      style: { textAlign: "left" },
                      autoComplete: "off",
                    })}
                  </InputGroupBlack>
                );
              case FormControlType.FORMATTED_TEXT:
                return (
                  <InputGroupBlack key={item.fieldName}>
                    <LabelBlack style={item.labelStyle}>
                      {item.caption}
                    </LabelBlack>
                    {getControl(item, {
                      type: "text",
                      style: { textAlign: "left" },
                      autoComplete: "off",
                      value: data[item.fieldName],
                    })}
                  </InputGroupBlack>
                );

              case FormControlType.DECIMAL:
                return (
                  <InputGroupBlack key={item.fieldName}>
                    <LabelBlack
                      style={{ alignItems: "start", ...item.labelStyle }}
                    >
                      {item.caption}
                    </LabelBlack>

                    {getControl(item, {
                      type: "text",
                      onBlur: (e) => onDecimalBlure(e, 0),
                      onFocus: onDecimalFocus,
                      onKeyDown: item?.onKeyDown ?? onKeyDown,
                      style: { textAlign: "right" },
                      placeholder: "0.00",
                      autoComplete: "off",
                    })}
                  </InputGroupBlack>
                );

              case FormControlType.DECIMAL_LOCK_VALUE:
                return (
                  <InputGroupBlack key={item.fieldName}>
                    <LabelBlack
                      style={{ alignItems: "start", ...item.labelStyle }}
                    >
                      {item.caption}
                    </LabelBlack>

                    {getControl(item, {
                      type: "text",
                      onBlur: (e) => onDecimalBlure(e, 0),
                      onFocus: onDecimalFocus,
                      onKeyDown: item?.onKeyDown ?? onKeyDown,
                      style: { textAlign: "right" },
                      placeholder: "0.00",
                      autoComplete: "off",
                      // defaultValue: data[item.fieldName],
                      value: data[item.fieldName],
                    })}
                  </InputGroupBlack>
                );

              case FormControlType.NUMERIC:
                return (
                  <InputGroupBlack key={item.fieldName}>
                    <LabelBlack style={item.labelStyle}>
                      {item.caption}
                    </LabelBlack>
                    {getControl(item, {
                      type: "text",
                      onBlur: (e) => onNumberBlure(e, 0),
                      onFocus: onDecimalFocus,
                      onKeyDown: item?.onKeyDown ?? onKeyDown,
                      style: item?.style ?? { textAlign: "left" },
                      placeholder: "0",
                      autoComplete: "off",
                      value: data[item.fieldName],
                    })}
                  </InputGroupBlack>
                );

              case FormControlType.PASSWORD:
                return (
                  <InputGroupBlack key={item.fieldName}>
                    <LabelBlack style={item.labelStyle}>
                      {item.caption}
                    </LabelBlack>
                    {getControl(item, { type: "password" })}
                  </InputGroupBlack>
                );

              case FormControlType.TEXT_AREA:
                return (
                  <InputGroupBlack key={item.fieldName}>
                    <LabelBlack
                      style={{ alignItems: "start", ...item.labelStyle }}
                    >
                      {item.caption}
                    </LabelBlack>
                    {getControl(item, {
                      as: "textarea",
                      rows: item.textRows ?? 5,
                      paddingInlineStart: "10px",
                    })}
                  </InputGroupBlack>
                );

              case FormControlType.DATE_PICKER:
                return (
                  <InputGroupBlack key={item.fieldName}>
                    <LabelBlack style={item.labelStyle}>
                      {item.caption}
                    </LabelBlack>
                    <DateArea>
                      <DateTimePicker
                        // disableClick={false}
                        name={item.fieldName}
                        // value={data[item.fieldName]}
                        value={MysqlDateCV(data[item.fieldName])}
                        onChange={
                          item.onChange ?? ((e) => onTextChange(e, item))
                        }
                        format={item?.dateFormat ?? "dd/MM/yyyy"}
                        locale="th-TH"
                        disabled={item?.readOnly}
                        // onCalendarOpen={(e) => alert(e)}
                        // onInvalidChange={(e) => alert(e)}
                        clearIcon={false}
                      />
                    </DateArea>
                  </InputGroupBlack>
                );

              case FormControlType.SELECT:
                return (
                  <InputGroupBlack key={item.fieldName}>
                    <LabelBlack style={item.labelStyle}>
                      {item.caption}
                    </LabelBlack>
                    <ModalSelectBlack
                      aria-label="ตัวเลือก"
                      key={item.fieldName}
                      name={item.fieldName}
                      defaultValue={item.oValue}
                      disabled={item.disabled}
                      value={GetDeepValue(
                        data[item.fieldName],
                        item.selectValueName,
                        data[item.fieldName],
                      )}
                      onClick={item.onClick}
                      onChange={
                        item.onChange
                          ? (e) => item.onChange(e.target.value, item, e)
                          : (e) => onSelectChange(e.target.value, item, e)
                        //  (e) => onTextChange(e.target.value, item)
                      }
                      style={{ ...{ minWidth: "100%" }, ...item.inputStyle }}
                    >
                      {/* add header row */}

                      {item.selectHasFirstOption && (
                        <option key="all" value="-1">
                          <span
                            style={{ color: "var(--input-place-holder-color)" }}
                          >
                            {item?.firstRowText ?? "** ไม่ระบุ"}{" "}
                          </span>
                        </option>
                      )}
                      {/* Add each items */}
                      {item.selectData &&
                        item.selectData.map((sItem) => {
                          return (
                            <option
                              key={GetDeepValue(
                                sItem,
                                item?.selectValueName ?? "id",
                                0,
                              )}
                              tag={GetDeepValue(
                                sItem,
                                item?.selectValueName ?? "id",
                                0,
                              )}
                              value={GetDeepValue(
                                sItem,
                                item?.selectValueName ?? "id",
                                0,
                              )}
                            >
                              {GetDeepValue(sItem, item?.selectDisplayName)}
                            </option>
                          );
                        })}
                    </ModalSelectBlack>
                  </InputGroupBlack>
                );

              case FormControlType.LABEL:
                return (
                  <InputGroupBlack key={item.fieldName}>
                    <LabelBlack style={item.labelStyle}>
                      {item.caption}
                    </LabelBlack>
                    <LabelBlack>{data[item.fieldName]}</LabelBlack>
                  </InputGroupBlack>
                );

              case FormControlType.SEARCHER:
                return (
                  <InputGroupBlack key={item.fieldName}>
                    <LabelBlack style={item.labelStyle}>
                      {item.caption}
                    </LabelBlack>
                    <FinderBox>
                      <FormControlBlack
                        type="text"
                        key={item.fieldName}
                        value={GetDeepValue(
                          data[item?.fieldName],
                          item?.searchDisplayName ?? "name",
                          item?.searchDisplayDefault ?? "",
                        )}
                        readOnly
                      />
                      {!item?.readOnly &&
                        CreateTooltip(
                          "ค้นหา",
                          <Button
                            style={{ zIndex: "0" }}
                            onClick={() =>
                              item.searchButtonClick &&
                              item.searchButtonClick(item)
                            }
                          >
                            ...
                          </Button>,
                        )}
                      {!item?.readOnly &&
                        CreateTooltip(
                          "Clear",
                          <Button
                            style={{ marginInlineStart: "2px", zIndex: "0" }}
                            variant="danger"
                            onClick={() =>
                              item.searchCancelClick &&
                              item.searchCancelClick(item, setData)
                            }
                          >
                            {/* <FaAsterisk /> */}X
                          </Button>,
                        )}
                    </FinderBox>
                  </InputGroupBlack>
                );

              case FormControlType.CHECK_BOX:
                return (
                  <InputGroupBlack
                    style={
                      item.style ?? {
                        flex: "1",
                        display: "flex",
                        justifyContent: "start",
                      }
                    }
                    key={item.fieldName}
                  >
                    <Form.Check
                      id={item.fieldName}
                      key={item.fieldName}
                      name={item.fieldName}
                      style={{ color: "var(--x-fore-primary)" }}
                      type="switch"
                      label={item.caption}
                      checked={data[item.fieldName] ?? false}
                      onChange={(e) => onCheckBoxChange(e.target.checked, item)}
                    />
                  </InputGroupBlack>
                );

              default:
                return <></>;
            }
          }) // map
      }
    </Form>
  );
}

//const InputGroup =  styled.

const FinderBox = styled.div`
  flex: 1;
  display: flex;
`;

const DateArea = styled.div`
  display: flex;
  margin-left: 5px;
  color: #121212;
`;

export const ButtonStyle1 = {
  margin: "1px",
  minWidth: "120px",
};

export const ButtonCancelStyle = {
  margin: "1px",
  minWidth: "120px",
  backgroundColor: "#ec640a",
};

export const ModalTitle1 = {
  color: "var(--thirth-text-color)",
};
